// Base URLS
//export const BASE_PROD = 'https://factstream.vercel.app/';
export const BASE_LOCAL = 'https://factstreamapi.herokuapp.com/';
//export const BACKEND_API = 'https://factstreamapi.herokuapp.com/';
//export const BACKEND_API = 'https://factstream.liberomeet.io/';
//export const BACKEND_API = 'http://10.10.2.78:9099/';

export const TEARSHEET_API = 'http://10.10.2.119:5000/api/ExcelTemplateMapper/getexcel/';
export const DOCEXPORT_API = 'http://14.98.3.227:8802/Synonym';
//  export const BACKEND_API = 'http://164.52.211.233:8083/';
 //export const BACKEND_API = 'http://14.98.3.228:5012/';
 export const BACKEND_API = process.env.REACT_APP_BACKEND_API;

// export const BACKEND_API = 'http://65.0.38.4:8083/';
// export const BACKEND_API = 'http://127.0.0.1:8000/';
// export const DAL_API = 'http://10.10.2.128:5012/api/v1.0/UiReq/'
// export const DAL_META = 'http://10.10.2.128:5012/api/v1.0/'

 export const DAL_API = 'http://164.52.211.233:5010/api/v1.0/UiReq/'

 export const DAL_META = 'http://164.52.211.233:5010/api/v1.0/'
// export const DAL_API = 'http://14.98.3.228:5010/api/v1.0/UiReq/'
// export const DAL_API = 'http://10.10.2.128:5012/api/v1.0/UiReq/'

// export const BACKEND_API_Demo = 'https://fact-stream-api.herokuapp.com/';

// export const AUTH_LOGIN = '/api/auth/login';
// export const AUTH_LOGIN = `${BACKEND_API}api/login/`;
export const AUTH_LOGIN = `${BACKEND_API}api/v1/BondCovenants/Auth/ValidateUser`;
export const GET_USER = `${BACKEND_API}api/users/me/`;
export const CREATE_USER = `${BACKEND_API}api/users/`;
export const LOG_OUT = `${BACKEND_API}api/logout/`;


export const TIMESERIES_DATA =  `${DAL_API}GetTimeSeriesData`;
// export const TIMESERIES_DATA =  `http://10.10.2.128:5011/api/v1.0/UiReq/GetTimeSeriesData`;

export const NORMALISED_DATA =  `${DAL_API}GetNormalizedData`;
export const DAL_COMPANY_LIST =  (page: any) => `${DAL_API}Companies?page=${page}`; 
export const DAL_SEARCH = (page: any, text: any) => `${DAL_API}FindCompany?page=${page}&companyName=${text}`
// export const DAL_COMPANY_SEARCH = (page: any, text: any) => `${DAL_API}FindCompany?page=${page}&companyName=${text}`
export const DAL_COMPANY_SEARCH = (page: any, text: any,clientid: any,active: any) => `${DAL_API}FindCompany?page=${page}&companyName=${text}&clientId=${clientid}&activeOnly=${active}&companyIsin=${text}`
export const DAL_COMPANIES_BLOCKS = (company_id: any) => `${DAL_API}BlocksData?companyId=${company_id}`;
export const DAL_DOCUMENT = (documentid: any) => `${DAL_API}Document?documentId=${documentid}`
export const DAL_DOCUMENTS_PATH = (companyid: any, documentid: any) => `${DAL_API}DocumentPath?companyId=${companyid}&documentId=${documentid}`
export const DAL_DOCUMENTS = (companyid: any, page: any, size: any) => `${DAL_API}Documents?companyId=${companyid}&page=${page}&customPageSize=${size}`
export const DAL_DOCUMENTS_PROCESSED = (companyid: any, page: any, size: any) => `${DAL_API}Documents?companyId=${companyid}&page=${page}&customPageSize=${size}&customPageSize=0&filterStage1=true&filterStage2=true&isFactStream=false&isCreditStream=false&isAlphaStream=false&isESG=false`
export const DAL_COMPANY_DETAIL = (companyid: any) => `${DAL_API}Company?companyId=${companyid}`;
export const DAL_COMPANY_DOCUMENTS = (companyid: any) => `${DAL_API}TSDocuments?companyId=${companyid}`;
export const DAL_CRAWLER_MAP_LIST = (companyid: any) => `${DAL_API}GetCrawlerMapping?companyId=${companyid}`;
export const DAL_CRAWLER_MAP_ADD=  `${DAL_API}AddCrawlerMapping`;



export const COMPANIES = `${BACKEND_API}api/companies/`;
//export const COMPANIES = `https://factstream.liberomeet.io/api/companies/`;
export const FILINGS = `${BACKEND_API}api/filings/`;
export const PERIODS = `${BACKEND_API}api/periods/`;
export const TERMS = `${BACKEND_API}api/terms/`;
export const SECTORS = `${BACKEND_API}api/sectors/`;
export const QUATERLY = `${BACKEND_API}api/quaterlies/`;
export const COUNTRIES = `${BACKEND_API}api/countries/`;
export const MEDIA = `${BACKEND_API}api/media/`;



export const DAL_COMPANIES_LIST = `${DAL_META}MetaData/AllCompany`;
//export const COMPANIES = `https://factstream.liberomeet.io/api/companies/`;
export const DAL_PERIODS_LIST = `${DAL_META}MetaData/Period`;
export const DAL_SOURCE_LIST = `${DAL_META}MetaData/DocumentSource`;
export const DAL_FILINGTYPE_LIST = `${DAL_META}MetaData/FilingType`;  
export const DAL_FILEFORMAT_LIST = `${DAL_META}MetaData/FileFormat`;
export const DAL_LANGUAGE_LIST = `${DAL_META}MetaData/Language`;
export const DAL_DOCUMENT_SOURCE = `${DAL_META}MetaData/DocumentSource`;



export const DAL_CURRENCY_LIST = `${DAL_META}MetaData/Currency`;
export const DAL_QUANTUM_LIST = `${DAL_META}MetaData/Quantum`;
export const DAL_ALL_CLIENTS_LIST = `${DAL_META}MetaData/Clients`;
export const DAL_SECTOR = `${DAL_META}MetaData/Sector`;
export const DAL_COMPANY_TYPE= `${DAL_META}MetaData/CompanyType`;
export const DAL_EXCHANGE_TYPE= `${DAL_META}MetaData/ExchangeType`;
export const DAL_INDUSTRY_GROUP= `${DAL_META}MetaData/IndustryGroup`;
export const DAL_INDUSTRY= `${DAL_META}MetaData/Industry`;
export const DAL_SUB_INDUSTRY= `${DAL_META}MetaData/SubIndustry`;
export const DAL_GEO= `${DAL_META}MetaData/Geo`;
export const DAL_COUNTRIES= `${DAL_META}MetaData/AllCountry`;
export const DAL_COMPANY_CAP= `${DAL_META}MetaData/CompanyCap`;
export const DAL_FISCAL_YEAR= `${DAL_META}MetaData/FiscalYear`;
export const DAL_TEMPLATE_LIST = `${DAL_META}MetaData/Templates`;

export const DAL_CLIENT_LIST = `${DAL_META}MetaData/Clients`;
export const DAL_PRODUCT_LIST = `${DAL_META}MetaData/Products`;

export const DAL_COMPANY_UPDATE = `${DAL_META}Company/Update`;
export const DAL_COMPANY_INSERT = `${DAL_META}Company/Create`;
export const DAL_MAP_COMPANY_PRODUCT = `${DAL_META}Company/MapCompaniesToProduct`;
export const DAL_UNMAP_COMPANY_PRODUCT = `${DAL_META}Company/UnMapCompaniesToProduct`;
export const DAL_MAP_COMPANY_CLIENT = `${DAL_META}Company/MapCompaniesToClient`;
export const DAL_UNMAP_COMPANY_CLIENT = `${DAL_META}Company/UnMapCompaniesToClient`;


export const DAL_ADD_FILING = `${BACKEND_API}api/media/`;
export const DAL_ADD_MEDIA = `${BACKEND_API}api/media/`;
export const DAL_ADD_COMPANY = `${BACKEND_API}api/media/`;



export const DAL_COMPANY_DETAIL_EDIT = (name: any) => `${DAL_META}MetaData/CompanyInfo?name=${name}`;


// export const GATEWAY_API = 'http://164.52.211.233:5000/';
// export const GATEWAY_API = 'http://14.98.3.228:5000/';
export const GATEWAY_API = 'http://127.0.0.1:5000/';

export const GATEWAY_SIMULALTE_API = `${GATEWAY_API}api/simulate/rb4f8bjs2225811eb80chs83afa2ccf8ca`;
export const GATEWAY_DOC_SUBMISSION =  `${GATEWAY_API}api/docids`;
export const GATEWAY_FETCH_STATUS = (doc_id: any) => `${GATEWAY_API}api/status/simulate/${doc_id}`;
export const GATEWAY_ADD_FILING = `${GATEWAY_API}api/simulate/rb4f8bjs2225811eb80chs83afa2ccf8ca`;
export const SNIPPET_API_IP = `https://dal-qa.alphastream.ai/api/`;
export const SNIPPET_VERSION = `v1.0/`;
export const GET_COVENANT_NAMES = `${SNIPPET_API_IP}${SNIPPET_VERSION}USIndenture/STD1/GetCovenantNames`;
export const GET_KEY_POINT = `${SNIPPET_API_IP}${SNIPPET_VERSION}USIndenture/STD1/GetKeyDataPoints`;
export const GET_DATA_POINT = `${SNIPPET_API_IP}${SNIPPET_VERSION}USIndenture/STD1/GetOptions`;
export const GET_DATA_SECTION = `${SNIPPET_API_IP}${SNIPPET_VERSION}USIndenture/STD1/GetBoundarySections`;
export const RETRIEVE_QUERY = `${SNIPPET_API_IP}${SNIPPET_VERSION}USIndenture/STD1/RetrieveQuery`;
export const GET_SAVED_QUERY = `${SNIPPET_API_IP}${SNIPPET_VERSION}CreditAgreement/GetSavedQueries`;
export const INSERT_QUERY = `${SNIPPET_API_IP}${SNIPPET_VERSION}USIndenture/STD1/InsertQuery`;
export const RETRIEVE_QUERY_QAD = `${SNIPPET_API_IP}${SNIPPET_VERSION}CreditAgreement/RetrieveQueryQAD`;
export const INSERT_QUERY_QAD = `${SNIPPET_API_IP}${SNIPPET_VERSION}CreditAgreement/InsertQueryQAD`;
export const GET_OPTION_QAD = `${SNIPPET_API_IP}${SNIPPET_VERSION}CreditAgreement/GetOptionsQAD`;



export const GET_PARSED_PDF_NAMES =`${SNIPPET_API_IP}${SNIPPET_VERSION}CreditAgreement/GetParsedPdfs`;
export const GET_TAX_FILTERS =`${SNIPPET_API_IP}${SNIPPET_VERSION}CreditAgreement/GetTaxFilters`;
export const GET_FILTER_OPTIONIDS =`${SNIPPET_API_IP}${SNIPPET_VERSION}CreditAgreement/GetOptionIdsByFilterId`;
export const GET_ERROR_LIST =`${SNIPPET_API_IP}${SNIPPET_VERSION}CreditAgreement/GetMasterErrorDetails`;
export const INSERT_ERROR_DETAILS =`${SNIPPET_API_IP}${SNIPPET_VERSION}CreditAgreement/InsertErrorIdDetails`;

export const SNIPPET_QA = `http://10.10.2.78:5007/ui`;
// export const SNIPPET_PARSER = `http://10.10.2.67:5001/mm-ca-parser`;
export const SNIPPET_PARSER = `http://14.98.3.227:8001/elastic`;
// export const SNIPPET_TRAINING_DATA = `http://10.10.2.67:5013/elastic`;
export const SNIPPET_TRAINING_DATA  = (port: any) =>  `http://10.10.2.67:8827/elastic`;
export const SNIPPET_TR_DATA = `${SNIPPET_API_IP}${SNIPPET_VERSION}USIndenture/STD1/Submit`;

export const SNIPPET_TRAINING_DATA_DEV = `http://10.10.2.67:8827/elastic`;
export const SNIPPET_REGRESSION = `http://10.10.2.78:5009/batchrun`;

export const GET_PARSED_DATA =`${SNIPPET_API_IP}${SNIPPET_VERSION}CreditAgreement/GetParsedDataByPDFName`;
export const GET_PARSED_PDFS =`${SNIPPET_API_IP}${SNIPPET_VERSION}USIndenture/Parser/GetParsedPdfs`;

export const GET_PARSED_DATAS =`${SNIPPET_API_IP}${SNIPPET_VERSION}USIndenture/Parser/GetParsedData`;
export const INSERT_UPD_DETAILS =`${SNIPPET_API_IP}${SNIPPET_VERSION}USIndenture/Parser/UpdateDataPoint`;
export const GET_PARSED_COVDATA =`${SNIPPET_API_IP}${SNIPPET_VERSION}BondCovenants/STD1/GetCovenantNames`;
export const GET_TAX_FILTER =`${SNIPPET_API_IP}${SNIPPET_VERSION}BondCovenants/Parser/GetTaxFilters`;
export const GET_FILTER_OPTIONID =`${SNIPPET_API_IP}${SNIPPET_VERSION}BondCovenants/Parser/GetOptionIdsByFilterIds`;
export const INSERT_APPROVED_STATUS =`${SNIPPET_API_IP}${SNIPPET_VERSION}USIndenture/Parser/UpdateDataPointsApprovedStatus`;
export const INSERT_PUBLISH =`${SNIPPET_API_IP}${SNIPPET_VERSION}USIndenture/Parser/Publish`;
// export const PARSER_PDF  =   `http://14.98.3.230:5006/us-indenture/`;
export const PARSER_PDF  =   `https://ws-test.alphastream.ai/us-indenture/files/`;
export const INSERT_REGRESSION =`${SNIPPET_API_IP}${SNIPPET_VERSION}USIndenture/Parser/GetParsedDataRegression`;
export const FETCH_INDEXES = `${SNIPPET_API_IP}${SNIPPET_VERSION}USIndenture/STD2/FetchIndexes`;
export const FETCH_DOCUMENT_BY_INDEXES = `${SNIPPET_API_IP}${SNIPPET_VERSION}USIndenture/STD2/FetchDocumentsByIndex`;
export const GET_PRODUCT_NAMES = `${SNIPPET_API_IP}${SNIPPET_VERSION}USIndenture/STD1/GetProductNames`;




